<template>
  <div class="timer-widget mt-2">
      <div class="display">
          {{ minutes }}:{{ secondsFormatted }}
      </div>
      <div class="buttons">
          <button @click="startStopToggle()">
              {{ isRunning ? 'Stop' : 'Start' }}
          </button>
          <button @click="resetTimer()">Reset</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
          isRunning: false,
          interval: null,
          seconds: 0
      };
  },
  computed: {
      minutes() {
          return Math.floor(this.seconds / 60);
      },
      secondsFormatted() {
          return (this.seconds % 60).toString().padStart(2, '0');
      }
  },
  methods: {
      startStopToggle() {
          this.isRunning = !this.isRunning;

          if (this.isRunning) {
              this.interval = setInterval(() => {
                  this.seconds++;
              }, 1000);
          } else {
              clearInterval(this.interval);
          }
      },
      resetTimer() {
          clearInterval(this.interval);
          this.isRunning = false;
          this.seconds = 0;
      }
  },
  beforeDestroy() {
      clearInterval(this.interval);
  }
}
</script>

<style scoped>
.timer-widget {
  width: 100%;  /* Updated to full width */
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
}

.display {
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  font-size: 24px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

button {
  width: 48%;
  height: 40px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  font-size: 18px;
}
</style>
